<template>
  <div class="modal">
    <div class="overlay" @click="closeModal"></div>
    <div class="wrapper">
      <div class="form">
        <div class="form-wrapper">
          <img class="close" @click="closeModal" src="@/assets/icons/close.svg" />
          <div class="form-fields">
            <div class="title">{{ $t('SELL YOUR SKINS') }}</div>
            <div class="form-fields-wrapper">
              <FloatingLabelInput
                type="text"
                :placeholder="$t('Enter skin name')"
                :label="$t('Enter skin name')"
                v-model="title"
                required
              />
              <FloatingLabelInput
                type="number"
                :placeholder="$t('Desired price')"
                :label="$t('Desired price')"
                v-model="price"
                required
              />
              <label>
                <select v-model="quality" required :class="{ empty: !quality }">
                  <option value="" selected disabled>{{ $t('Quality') }}</option>
                  <option v-for="(item, i) in qualityOptions" :value="item" :key="i">
                    {{ item }}
                  </option>
                </select>
              </label>
              <FloatingLabelInput
                type="text"
                :placeholder="$t('Steam inventory link to skin')"
                :label="$t('Steam inventory link to skin')"
                v-model="item_url"
                required
              />
            </div>
            <div class="cta-container">
              <div class="buttons">
                <div class="button" @click="closeModal">
                  <span>{{ $t('CANCEL') }}</span>
                </div>
                <div class="button green" @click="create" :disabled="loading">
                  <span v-if="!loading">{{ $t('Send') }}</span>
                  <Spinner v-else />
                </div>
              </div>
            </div>
            <transition name="fade">
              <div v-if="error" class="error-desc desc red">
                {{ error }}
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import Spinner from '@/components/shared/Spinner.vue'
  import FloatingLabelInput from '@/components/shared/FloatingLabelInput.vue'

  export default {
    name: 'SaleSkinModal',
    components: {
      Spinner,
      FloatingLabelInput
    },
    data: function () {
      return {
        title: '',
        price: '',
        quality: '',
        item_url: '',
        qualityOptions: ['Field-Tested', 'Minimal Wear', 'Battle-Scarred', 'Well-Worn', 'Factory New', 'Not Painted'],
        loading: false,
        error: ''
      }
    },
    computed: {
      ...mapGetters('app', ['currencyCode'])
    },
    methods: {
      ...mapActions('modals', ['closeSaleSkinModal']),
      ...mapActions('offer', ['createOffer']),
      closeModal() {
        this.closeSaleSkinModal()
      },
      async create() {
        if (!this.title || !this.price || !this.quality || !this.item_url) {
          this.error = 'Please fill in all fields.'
          return
        }
        this.loading = true
        this.error = ''
        let data = {
          title: this.title,
          price: this.price,
          quality: this.quality,
          item_url: this.item_url,
          currency: this.currencyCode
        }
        try {
          await this.createOffer(data)
          this.$toast.success('Offer sent successfully.')
          this.closeModal()
          this.$router.push({ name: 'OfferSuccessPage' })
        } catch (error) {
          this.error = error
          this.$toast.error(error)
        } finally {
          this.loading = false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .modal {
    .overlay {
      // Styles for the overlay
    }

    .wrapper {
      padding: 56px 44px;

      .form {
        .form-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;

          .close {
            // Styles for the close button
          }

          .form-fields {
            max-width: 304px;
            width: 100%;
            .title {
              text-align: center;
              text-transform: uppercase;
              font-size: 32px;
              font-weight: 700;
              margin-bottom: 36px;
            }

            .form-fields-wrapper {
              display: grid;
              grid-template-columns: repeat(1, 1fr);
              gap: 12px 20px;
              justify-items: center;
              align-items: center;
              justify-content: center;

              label {
                position: relative;
                height: 50px;
                display: inline-block;
                width: 100%;
              }
            }

            .cta-container {
              margin-top: 26px;
              text-align: center;

              .buttons {
                display: flex;
                gap: 16px;
                justify-content: center;

                .button {
                  flex: 1;
                  max-width: 304px;

                  &.green {
                    background-color: #90fc3c;
                    color: #131214;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  select {
    -moz-appearance: none;
    appearance: none;
    -webkit-appearance: none;
    height: 50px;
    background-color: transparent;
    border: 1px solid #626165;
    padding: 14px 15px 14px 16px;
    color: #fff;
    font-size: 14px;
    line-height: 1.5;
    width: 100%;
    cursor: pointer;

    &.empty {
      color: #88868d;
    }

    option {
      -webkit-appearance: none;
      height: 50px;
      background-color: #2b2a2c;
      border: 1px solid #626165;
      padding: 14px 15px 14px 16px;
      color: #fff;
      font-size: 14px;
      line-height: 1.5;
      width: 100%;
    }
  }

  @media (max-width: 600px) {
    .modal .wrapper .form .form-wrapper .form-fields .form-fields-wrapper {
      grid-template-columns: repeat(1, 1fr);
    }
  }

  @media (max-width: 460px) {
    .form-fields-wrapper {
      flex-direction: column;
      align-items: center;
    }
  }
</style>
